import dtm from 'scripts/services/dtm';

const getAlertType = (type) => {
    switch (type) {
        case 'liveVideo':
        case 'liveStream':
            return 'Favorite Player Live Stream';
        case 'videoCard':
            return 'Favorite Player VOD';
        case 'photoCard':
            return 'Favorite Player Photo Gallery';
        case 'articleCard':
            return 'Favorite Player Article';
        case 'leaderFinish':
            return 'Leader Scoring';
        case 'ltParFinish':
            return 'Favorite Player Scoring';
        default:
            return null;
    }
};

export function sendClickAnalytics(alert) {
    const analyticAlertType = getAlertType(_.get(alert, 'type'));
    const text = _.get(alert, 'text');

    if (!analyticAlertType || !text) {
        return;
    }

    dtm.trackAlertButtonClick(text, analyticAlertType);
}
